import { Component } from "@angular/core";

@Component({
  standalone: true,
  selector: "plants-banner",
  templateUrl: "plants-banner.component.html",
  styleUrls: ["plants-banner.component.scss"]
})
export class PlantsBannerComponent {}
